/*
 * @Author: Yue Hu(yuhu@nvidia.com)
 * @Date: 2024-11-19 23:31:31
 * @LastEditors: Yue Hu(yuhu@nvidia.com)
 * @LastEditTime: 2024-11-22 00:15:10
 * @FilePath: /mooctest.com/src/utils/request.js
 */
import axios from "axios";
import { Message } from "element-ui";
import { t } from "../i18n/i18n";

import { showScreenLoading, hideScreenLoading } from "./loading";

function handleLoading(config, show = true) {
  if (config?.otherOptions?.showLoading) {
    if (show) {
      showScreenLoading(config?.otherOptions?.loadingSetting);
    } else {
      hideScreenLoading();
    }
  }
}
axios.defaults.withCredentials = true;
// create an axios instance
const service = axios.create({
  // API
  baseURL: "/api",
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 100000, // request timeout
});

// response interceptor
service.interceptors.response.use(
  /** 1、头、request、返回值变化的策略、、todo
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * 可以通过自定义状态码进行全局的拦截控制,没有约定的话就不做处理
   */
  (response) => {
    handleLoading(response.config, false);
    const res = response.data;
    return res;
  },
  (error) => {
    handleLoading(error.config, false);
    console.log("response err", error);
    if (error.response.status.toString().startsWith("50")) {
      Message({
        message: t("requestError.serverError"),
        type: "error",
        duration: 3 * 1000,
      });
    }
    if (
      error.response.data.error &&
      error.response.data.error === "Unauthorized"
    ) {
      Message({
        message: t("requestError.loginTimeout"),
        type: "error",
        duration: 3 * 1000,
      });
      setTimeout(() => {
        window.location.href = "/#/login";
      }, 3000);
    }
    return Promise.reject(error);
  },
);
// request interceptor

service.interceptors.request.use(
  (config) => {
    handleLoading(config, true);
    const token = window.localStorage.getItem("accessToken");
    if (token) {
      const newConfig = { ...config };
      newConfig.headers = { ...newConfig.headers, accessToken: token };
      return newConfig;
    }
    return config;
  },
  (error) => {
    console.log("request err", error);
    handleLoading(error.config, false);
    Message({
      message: t("requestError.timeout"),
      type: "error",
      duration: 3 * 1000,
    });
    return Promise.reject(error);
  },
);

export default service;
